


































































import { Component, Mixins } from 'vue-property-decorator';
import papybaseConfig from '@/plugins/papybase/papybaseConfig';
import IsMobileMixin from '@/mixins/vue/IsMobileMixin';

@Component
export default class EmailConfirmationWithCode extends Mixins(IsMobileMixin) {
    public processingEmailConfirmation = true;

    public isEmailConfirmationSuccess = false;

    public created() {
        if (this.code) {
            const URL = `${papybaseConfig.baseURL}/auth/email-confirmation?confirmation=${this.code}`;
            window.location.replace(URL);
            return;
        }

        if (this.confirmed === 'success') {
            this.isEmailConfirmationSuccess = true;
        } else {
            this.isEmailConfirmationSuccess = false;
        }
        this.processingEmailConfirmation = false;
    }

    get code(): string {
        if (this.$route.query.confirmation) {
            return (this.$route.query.confirmation as string);
        }
        return '';
    }

    get confirmed(): string {
        if (this.$route.query.confirmed) {
            return (this.$route.query.confirmed as string);
        }
        return 'failure';
    }
}
